const shareLinks = document.querySelectorAll('.social-share-popup');

if (shareLinks) {
    shareLinks.forEach((link) => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            const url = this.getAttribute('href');

            const popupWidth = 960;
            const popupHeight = 450;

            const left = window.screen.width / 2 - popupWidth / 2;
            const top = window.screen.height / 2 - popupHeight / 2;

            window.open(
                url,
                'social-share',
                `width=${popupWidth},height=${popupHeight},top=${top},left=${left},scrollbars=yes,resizable=yes`
            );
        });
    });
}
